export type FollowingState = {
    email: string | null;
    setEmail: (_email: string | null) => void;

    clear: () => void;
};

export const followingStore = (
    set: (state: Partial<FollowingState>) => void,
    get: () => FollowingState,
): FollowingState => ({
    email: null,
    setEmail: (_email: string | null) => {
        const currentState = get();
        if (currentState.email !== _email)
            set({ ...currentState, email: _email });
    },
    clear: () => {
        set({ email: null });
    },
});
